import { IdealMeasuresLogState } from '../../Reducers/IdealTeeMeasuresLogReducer';
import { idealGarmentMeasurementsZero } from '../../tools/generalProperties';
import { UserDetails } from '../../types/contexts/userContext';

export const emptyUserDetailsInitialObject: UserDetails = {
  name: '',
  country: '',
  dob: '',
  email: '',
  firebase_uid: '',
  isadmin: false,
  unitcm: 1,
  user_id: 0,
  userMeasurements: {
    height: 0,
    chest: 0,
    waist: 0,
  },
  idealGarmentMeasurements: idealGarmentMeasurementsZero,
  bodyInfo: {
    fitType: "regular",
    bodyType: "regular",
    weight: 0,
  },
  idealteemeasureslog_id: 0,
  fitScoreWeightings: {
    armholeopening: 2,
    chest: 5,
    frontlength: 5,
    hem: 4,
    necktoshoulder: 0,
    neckwidth: 3,
    shouldertoshoulder: 3,
    sleevelength: 1,
    sleeveopening: 2,
    waist: 4,
  },
  timestamps: {
    idealGarmentMeasurements: new Date().toUTCString(),
  }
};

export function getInitialUserDetails(): UserDetails {
  // Check localStorage for userDetails. If there is none, initialise it ourselves and setLocalStorage. If there is some, return this for the inital state.
  const savedUserDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  if (Object.keys(savedUserDetails).length === 0) {
    localStorage.setItem("userDetails", JSON.stringify(emptyUserDetailsInitialObject))
    return emptyUserDetailsInitialObject;
  }
  return savedUserDetails;
}

export const initialIdealMeasuresHistoryLogEmpty: IdealMeasuresLogState = {
  selectedLog: 0,
  arrayOfLogs: [],
};

export function getInitialIdealMeasuresLogState(): IdealMeasuresLogState {

  // Check localStorage for userDetails. If there is none, initialise it ourselves and setLocalStorage. If there is some, return this for the inital state.
  const parsedLocalStorage = JSON.parse(localStorage.getItem('idealMeasuresLog') || '{}');
  if (Object.keys(parsedLocalStorage).length === 0) return initialIdealMeasuresHistoryLogEmpty;
  return parsedLocalStorage;
}

